// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"9d2c7a66","99":"10466735","453":"21db83d2","509":"32fee823","622":"3d1c94ae","667":"429d35c1","724":"20030266","812":"0567de4b","913":"c4395f0e","920":"9f651617","937":"338d72f1"}[chunkId] + ".chunk.js";
};